import { Link } from "react-router-dom";
import SectionHeader from "../../../components/section/SectionHeader";
import SectionTitle from "../../../components/section/SectionTitle";
import AdvancedPushNotificationForm from "../../../components/push-notification/AdvancedPushNotificationForm";
import PushCapabilitiesPanel from "../../../components/push-notification/PushCapabilitiesPanel";
import { usePushCapabilities } from "../../../hooks/push-notifications";

function PushNotificationCompose() {
  const capabilities = usePushCapabilities();

  return (
    <div className="relative mb-6 flex w-full min-w-0 flex-col break-words rounded bg-white p-2 shadow-lg">
      <div className="rounded-t border-0 px-4 py-3 pb-6">
        <SectionHeader>
          <SectionTitle title="Compose push notification" />
          <Link to="/push-notifications/history" className="text-sm font-semibold text-primary hover:underline">
            View history
          </Link>
        </SectionHeader>
      </div>
      <div className="px-4">
        <PushCapabilitiesPanel
          capabilities={capabilities.data}
          loading={capabilities.isLoading}
          error={capabilities.error}
        />
      </div>
      <div className="m-4 mb-8 flex-auto bg-neutral-light p-4 py-8">
        <AdvancedPushNotificationForm capabilities={capabilities.data} />
      </div>
    </div>
  );
}

export default PushNotificationCompose;
